import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';

interface State {
  failed: boolean;
}

function RecoveryScreen({ onRetry }: { onRetry: () => void }) {
  const { t } = useTranslation();

  return (
    <main className="flex min-h-screen flex-col items-center justify-center gap-4 p-6 text-center">
      <h1 className="text-xl font-semibold">{t('common.pageRenderFailed')}</h1>
      <p className="max-w-md text-sm text-muted-foreground">{t('common.pageRenderFailedHint')}</p>
      <Button onClick={onRetry}>{t('common.retry')}</Button>
    </main>
  );
}

/** Keep a failed render visible and recoverable without discarding the session. */
export class AppRenderErrorBoundary extends React.Component<React.PropsWithChildren, State> {
  state: State = { failed: false };

  static getDerivedStateFromError(): State {
    return { failed: true };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo): void {
    // Do not log the error message: it can contain customer or request data.
    console.error('Application render failed', error.name, info.componentStack);
  }

  render() {
    if (this.state.failed) {
      return <RecoveryScreen onRetry={() => this.setState({ failed: false })} />;
    }
    return this.props.children;
  }
}
